import React, { useState } from 'react';
import '../css/landing.css';
import '../css/LandingPage.why.css';
import '../css/how-it-works.css';
import '../css/new-opportunity.css';
import '../css/faq.css';
import '../css/cta-section.css';

import Navbar from './common/Navbar/Navbar';
import Footer from './common/Footer/Footer';
import DashboardEmbed from './AppView';

import Carousel from './common/Carousel/Carousel';

const FAQ_ITEMS = [
  {
    question: '¿Cómo funciona un datáfono crypto?',
    answer:
      'Datáfono Crypto es una app web que convierte tu celular en un punto de cobro. Registras tu negocio, ingresas el monto y el sistema genera un código QR. Tu cliente lo escanea con su wallet y paga en criptomonedas. Recibes la confirmación del pago en tu cuenta al instante, sin datáfono físico ni intermediarios bancarios.',
  },
  {
    question: '¿Qué criptomonedas aceptan?',
    answer:
      'Aceptamos criptomonedas activas en nuestras redes compatibles, como BNB, USDT y POL, entre otras. Al pagar, el cliente selecciona la moneda y la red disponibles desde su wallet para completar la transacción de forma segura.',
  },
  {
    question: '¿Cuáles son las comisiones?',
    answer:
      'La comisión es del 5% por transacción, clara y accesible. No hay costos de instalación ni mensualidades: solo pagas cuando recibes un cobro exitoso en tu negocio.',
  },
  {
    question: '¿Cómo me uno a la red?',
    answer:
      'Haz clic en "Usar la App", crea tu cuenta gratuita y registra tu negocio en minutos. Completa la verificación indicada y, una vez activo, podrás generar códigos QR y recibir pagos en crypto desde cualquier lugar.',
  },
];

const LandingPage = () => {
//embebed view
 const [showIframe, setShowIframe] = useState(false);
const [iframePath, setIframePath] = useState("");
const [openFaqIndex, setOpenFaqIndex] = useState(null);

const handleFaqToggle = (index) => {
  setOpenFaqIndex((prev) => (prev === index ? null : index));
};

// Función para mostrar login
const handleGoToApp = () => {
  setIframePath(""); // Ruta de login de la otra app
  setShowIframe(true);
};

// Función para mostrar registro
const handleGoToRegister = () => {
  setIframePath("register"); // Ruta de registro de la otra app
  setShowIframe(true);
};
  // eslint-disable-next-line no-unused-vars
  // const handleGoToApp = () => {
  //   if (window.location.hostname === 'localhost') {
  //     window.location.href = 'http://localhost:3000/';
  //   } else {
  //     window.location.href = '/app/';
  //   }
  // };

  return (
    <div className="landing-container">
      {/* Navbar Component */}
      <Navbar onGoToApp={handleGoToApp} onGoToRegister={handleGoToRegister}/>
       {!showIframe ? (
      <>
      {/* Hero Section */}
      <section className="hero-section">
        {/* Carousel de fondo */}
        <div className="hero-carousel-container">
          <Carousel />
        </div>
        {/* Gradiente responsive encima del carrusel */}
        <div className="hero-gradient-overlay"></div>
        {/* Contenido hero por encima */}
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Con tu <span className="hero-highlight">celular</span>,<br/>
              cobrá en <span className="hero-highlight">crypto</span><br/>
              sin fronteras.
            </h1>
            <div className="hero-description hero-description-custom">
              {/* Versión Desktop */}
              <span className="hero-description-desktop">
                Datáfono Crypto es una <span className="desc-bold">app</span> que permite a<br/>
                cualquier negocio recibir pagos en criptos a través<br/>
                de un código QR.<br/>
                No necesitás bancos, ni datáfonos especiales. Solo<br/>
                tu celular.
              </span>
              {/* Versión Móvil */}
              <span className="hero-description-mobile">
                Datáfono Crypto es una <span className="desc-bold">app</span> que<br/>
                permite a cualquier negocio recibir<br/>
                pagos en dólares digitales a través de<br/>
                un código QR.<br/>
                No necesitás bancos, ni datáfonos<br/>
                especiales. Solo tu celular.
              </span>
            </div>
            <div className="hero-appweb-section">
              <div className="hero-appweb-title-container">
                {/* Versión Desktop */}
                <h2 className="hero-appweb-title-desktop poppins-bold poppins-bold-desktop">
                  USÁ LA<br/>
                  <span className="hero-appweb-highlight">APLICACIÓN<br/>WEB</span>
                </h2>
                {/* Versión Móvil */}
                <h2 className="hero-appweb-title-mobile poppins-bold poppins-bold-mobile">
                  USÁ LA <span className="hero-appweb-highlight">APP WEB</span>
                </h2>
                {/* Versión Tablet */}
                <h2 className="hero-appweb-title-tablet poppins-bold poppins-bold-desktop">
                  USÁ LA <span className="hero-appweb-highlight">APP WEB</span>
                </h2>
              </div>
              <div className="hero-appweb-img-container">
                <img src="/images/qrPhone.png" alt="QR Phone" className="hero-appweb-img" />
              </div>
              <div className="hero-appweb-btn-container">
                <button className="hero-appweb-btn" onClick={handleGoToApp}>Usar la App</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <div className="section-why-flex">
          <div className="section-container left-why">
            <h2 className="section-title left-why">
              ¿Por qué <span className="highlight-yellow">elegir</span><br/>
              Datáfono Crypto?
            </h2>
            <div className="features-description left-why">
              Únete a la revolución de los pagos digitales y<br/>
              ofrece a tus clientes la experiencia más<br/>
              avanzada
            </div>
            <ul className="why-features-list">
              <li className="low-commissions-container">
                <span className="why-icon comisiones-bajas">
                  <img src="/images/div.png" alt="Check icon" />
                </span>
                <div className="why-texts">
                  <span className="why-title">Comisiones Bajas</span>
                  <span className="why-desc">Solo 5% por transacción, cómodo y accesible.</span>
                </div>
              </li>
              <li className="no-intermediaries-container">
                <span className="why-icon sin-intermediarios">
                  <img src="/images/div.png" alt="Check icon" />
                </span>
                <div className="why-texts">
                  <span className="why-title">Sin Intermediarios</span>
                  <span className="why-desc">Recibe los pagos directamente en tu tarjeta o cuenta, sin terceros</span>
                </div>
              </li>
              <li className="global-reach-container">
                <span className="why-icon alcance-global">
                  <img src="/images/div.png" alt="Check icon" />
                </span>
                <div className="why-texts">
                  <span className="why-title">Alcance Global</span>
                  <span className="why-desc">Acepta pagos de cualquier parte del mundo, sin restricciones</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="why-img-container">
            <img src="/images/CelQr.png" alt="Celular QR" className="why-img" />
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="section-container">
          <img src="/images/CelQr.png" alt="Celular QR" className="how-it-works-mobile-img" />
          <h2 className="section-title">Cómo Funciona</h2>
          <p className="section-description">Tres pasos simples para comenzar a recibir pagos crypto</p>
        </div>
        <div className="how-it-works-arrow-bg-cards">
          <img 
            src="/images/FlechaMulticolor.png" 
            alt="Flecha multicolor" 
            className="how-it-works-arrow-bg-img"
          />
          <div className="flechas-individuales">
            <div className="flecha-item">
              <img src="/images/Flecha1.png" alt="Flecha 1" className="flecha-individual" />
              <span className="flecha-number">1</span>
              <span className="flecha-title">Registra<br/>tu<br/>Cuenta</span>
              <div className="flecha-description">
                Crea tu cuenta gratuita y registra tu negocio en minutos.
              </div>
            </div>
            <div className="flecha-item">
              <img src="/images/Flecha2.png" alt="Flecha 2" className="flecha-individual" />
              <span className="flecha-number">2</span>
              <span className="flecha-title">Generar<br/>el QR</span>
              <div className="flecha-description">
                Ingresa el monto y el sistema generará automáticamente el código QR.
              </div>
            </div>
            <div className="flecha-item">
              <img src="/images/Flecha3.png" alt="Flecha 3" className="flecha-individual" />
              <span className="flecha-number">3</span>
              <span className="flecha-title">Recibe<br/>el Pago</span>
              <div className="flecha-description">
                Tu cliente escanea el QR y realiza el pago. Recibe confirmación en tu dashboard.
              </div>
            </div>
          </div>
          <div className="how-it-works-cards">
            <div className="how-it-works-card">
              <div className="card-header">
                <span className="card-number">1</span>
                <h3 className="card-title">Registra tu Dispositivo</h3>
              </div>
              <p className="card-description">
                Crea tu cuenta gratuita y<br/>
                registra tu negocio en<br/>
                minutos.
              </p>
            </div>
            <div className="how-it-works-card">
              <div className="card-header">
                <span className="card-number">2</span>
                <h3 className="card-title">Genera tu QR</h3>
              </div>
              <p className="card-description">Ingresa el monto y el sistema generará automáticamente el código QR.</p>
            </div>
            <div className="how-it-works-card">
              <div className="card-header">
                <span className="card-number">3</span>
                <h3 className="card-title">Recibe Pagos</h3>
              </div>
              <p className="card-description">Tu cliente escanea el QR y realiza el pago. Recibe confirmación en tu cuenta de usuario.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Título adicional fuera de la flecha */}
      <div className="crypto-impact-title">
        <span className="crypto-impact-title-desktop">
          Impacto del <span className="highlight-green">Mercado Crypto</span><br/>
          <span className="highlight-yellow">Latinoamérica</span>
        </span>
        <span className="crypto-impact-title-mobile">
          Impacto del<br/>
          <span className="highlight-green">Mercado Crypto</span><br/>
          <span className="highlight-yellow">Latinoamérica</span>
        </span>
      </div>

      {/* Tarjetas de estadísticas de impacto */}
      <div className="crypto-impact-stats">
        <div className="crypto-impact-stat">
          <div className="stat-value stat-yellow">+55M</div>
          <div className="stat-title">PERSONAS</div>
          <div className="stat-desc">en Latinoamérica usan cripto.</div>
        </div>
        <div className="crypto-impact-stat">
          <div className="stat-value stat-green">+415.000M</div>
          <div className="stat-title">DE DÓLARES</div>
          <div className="stat-desc">se mueven en cripto en Latinoamérica<br/>anualmente</div>
        </div>
        <div className="crypto-impact-stat">
          <div className="stat-value stat-yellow">+25M</div>
          <div className="stat-title">COMERCIOS EN LATAM</div>
          <div className="stat-desc">listas para integrar pagos en cripto</div>
        </div>
      </div>

      {/* Nueva Oportunidad Section */}
      <section id="new-opportunity" className="new-opportunity-section">
        <div className="section-container">
          <div className="new-opportunity-title-container">
            <h1 className="new-opportunity-title typography-title-large">
              <span style={{color: '#F9BC2B'}}>Nueva</span><br/>
              <span style={{color: '#FFFFFF'}}>oportunidad</span><br/>
              <span style={{color: '#FFFFFF'}}>crypto ideal para</span><br/>
              <span style={{color: '#F9BC2B'}}>E-Commerce</span>
            </h1>
            <p className="new-opportunity-description typography-description-regular-mobile">
              Cobros en cripto sin bancos,<br/>
              sin fronteras y con comisiones<br/>
              justas de forma eficiente.
            </p>
          </div>
          <div className="new-opportunity-btn-container">
            <button className="new-opportunity-btn typography-button-primary" onClick={handleGoToApp}>
              Usar la app
            </button>
          </div>
          <img 
            src="/images/newOpportunity.png" 
            alt="Nueva oportunidad crypto para E-Commerce" 
            className="new-opportunity-image"
          />
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faqs" className="faq-section">
        <div className="faq-title-container">
          <h2 className="faq-title-typography">
            <span className="word-preguntas">Preguntas</span>
            <span className="faq-title-break-mobile"></span>
            <span className="word-frecuentes">Frecuentes</span>
          </h2>
        </div>
        <div className="faq-description-container">
          <p className="faq-description-typography">
            Aclaramos tus dudas sobre Datáfono Crypto
          </p>
        </div>
        <div className="section-container">
          <div className="faq-accordion-list">
            {FAQ_ITEMS.map((item, index) => (
              <div
                key={item.question}
                className="faq-accordion-item"
                role="button"
                tabIndex={0}
                aria-expanded={openFaqIndex === index}
                onClick={() => handleFaqToggle(index)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleFaqToggle(index);
                  }
                }}
              >
                <div className="faq-accordion-header">
                  <span className="faq-question faq-accordion-text-mobile">{item.question}</span>
                  <span
                    className={`faq-arrow${openFaqIndex === index ? ' faq-arrow--open' : ''}`}
                    aria-hidden="true"
                  />
                </div>
                {openFaqIndex === index && (
                  <p className="faq-question faq-accordion-text-mobile faq-answer">{item.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="section-container">
          <h2 className="cta-title cta-title-typography-desktop">
            ¿Listo para<br className="mobile-only" />
            <span className="cta-revolucionar">revolucionar</span><br className="mobile-only" />
            tu negocio?
          </h2>
          <p className="cta-description">
            Únete a la revolución de pagos crypto, con<br className="mobile-only" />
            solo tu dispositivo y nuestra app cobra y<br className="mobile-only" />
            paga en crypto
          </p>
          <button className="cta-app-btn" onClick={handleGoToApp}>Usar la App</button>
          <div className="cta-benefits-row">
            <span className="cta-benefit"><span className="cta-check"><svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7L7.5 11L16 2" stroke="#DCFCE7" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Rápido</span>
            <span className="cta-benefit"><span className="cta-check"><svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7L7.5 11L16 2" stroke="#DCFCE7" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Seguro</span>
            <span className="cta-benefit"><span className="cta-check"><svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7L7.5 11L16 2" stroke="#DCFCE7" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Estable</span>
            <span className="cta-benefit cta-benefit-baja-comision"><span className="cta-check"><svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7L7.5 11L16 2" stroke="#DCFCE7" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Baja <br className="mobile-only" />comisión</span>
          </div>
        </div>
      </section>
      </>
        ) : (
           

          <DashboardEmbed onGoTopath={iframePath}  />
          )}
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage; 